<template>
    <ini-layout v-if="loaded" :title="ticket_title.displayValue" icon="ticket" return-page-path="/HelpDesk/Index">
        <template slot="summary">
            <ini-detail-summary :ticketcategories="ticketcategories" :ticketstatus="ticketstatus"
                                :ticketpriorities="ticketpriorities" @resolved-clicked="showResolveAlert"
                                :showAddCommentButton="!isResolved"
                                :showResolvedButton="!isResolved"></ini-detail-summary>
            <div ref="resolveModalContainer"></div>
        </template>
        <template slot="main">
            <div class="ini-detailview-card">
                <ini-description :contact_id="contact_id" :createdtime="createdtime" :description="description"
                                 :attachments="descriptionAttachments"
                                 @attachment-clicked="downloadAttachment"></ini-description>
                <ini-comment :showCommentControl="!isResolved" ref="comment" :items="comments"
                             @comment-submited="sendMessage" @attachment-clicked="downloadAttachment"></ini-comment>
            </div>
        </template>
        <template slot="custom">
            <div class="ini-detailview-card ini-detailview-card--sidebar">
                <ini-custom
                        :ticket-number="ticket_no.displayValue"
                        :opened-date="transformDateTime(createdtime).value"
                        :attachments="listAttachments"
                        :custom-fields="customFields"
                        :assigned-to="handledby"
                        @attachment-clicked="downloadAttachment"
                ></ini-custom>
            </div>
        </template>
    </ini-layout>
</template>

<script>
    import IniLayout from '@/layout/Detail'
    import IniModal from '@/components/Modal'
    import IniDetailSummary from '@/components/HelpDesk/Detail/Summary'
    import IniDescription from '@/components/HelpDesk/Detail/Description'
    import IniComment from '@/components/HelpDesk/Comment/Comment'
    import IniCustom from '@/components/HelpDesk/Detail/Custom'
    import StyleMixin from '@/mixins/StyleMixin'
    import cookies from "vue-js-cookie";

    export default {
        mixins: [StyleMixin],

        data() {
            return {
                loaded: false,
                ticket_title: {value: '', displayValue: ''},
                ticket_no: {value: '', displayValue: ''},
                description: {value: '', displayValue: ''},
                ticketcategories: {value: '', displayValue: ''},
                ticketstatus: {value: '', displayValue: ''},
                createdtime: {value: '', displayValue: ''},
                ticketpriorities: {value: '', displayValue: ''},
                handledby: {value: '', displayValue: ''},
                contact_id: {value: '', displayValue: ''},
                customFields: [],
                items: [
                    {
                        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaeca',
                        createdtime: {value: '2019-04-11 11:40:34', displayValue: '2019-04-11 11:40 AM'},
                        handledby: {value: '11', displayValue: 'Pierre-Mickael D.'},
                    },
                    {
                        isCurrentUser: true,
                        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaeca',
                        createdtime: {value: '2019-04-11 11:40:34', displayValue: '2019-04-11 11:40 AM'},
                        handledby: {value: '2', displayValue: 'John Wats'},
                    },
                    {
                        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaeca',
                        createdtime: {value: '2019-04-11 11:40:34', displayValue: '2019-04-11 11:40 AM'},
                        handledby: {value: '11', displayValue: 'Pierre-Mickael D.'},
                    }
                ],
                descriptionAttachments: [],
                listAttachments: []
            }
        },

        props: {
            record: String
        },

        components: {
            IniLayout,
            IniDetailSummary,
            IniDescription,
            IniComment,
            IniCustom,
        },

        methods: {
            isEligibleForInProgressStatus() {
                if (this.ticketstatus && this.ticketstatus.value === 'Wait For Response') {
                    return true
                }

                return false
            },

            async sendMessage(data) {
                let response = await Api.save('ModComments',
                    {'commentcontent': data.message, 'related_to': this.record}, null, data.attachments)

                if (response.success && this.isEligibleForInProgressStatus()) {
                    this.updateTicketStatus('In Progress')
                }

                this.$refs.comment.clear()
                this.loadComments()
            },

            async updateTicketStatus(statusValue) {
                let response = await Api.save('HelpDesk', {'ticketstatus': statusValue}, this.record)
                if (response.success) {
                    this.ticketstatus = response.result.ticketstatus
                    return true
                }

                return false
            },

            async downloadAttachment(attachment) {
                let response = await Api.download(attachment.id, true)

                var blob = new Blob([response], {type: 'application/octet-stream'})
                var link = document.createElement('a')
                var url = window.URL.createObjectURL(blob)

                link.href = url
                link.download = attachment.name
                document.body.appendChild(link);
                link.click()

                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
            },

            async loadRecordData() {
                try {
                    let response = await Api.fetchRecord(this.$route.params.record);
                    if (response.success) {
                        let details = response.result
                        this.ticket_title = details.ticket_title
                        this.ticket_no = details.ticket_no
                        this.description = details.description
                        this.ticketcategories = details.ticketcategories
                        this.ticketstatus = details.ticketstatus
                        this.ticketpriorities = details.ticketpriorities
                        this.createdtime = this.transformDateTime(details.createdtime)
                        this.handledby = details.assigned_user_id
                        this.contact_id = details.contact_id
                        const fields = this.$store.getters.getFields(this.module)
                        for (let field in details) {
                            if (field.startsWith('cf_')) {
                                this.customFields.push({
                                    label: fields[field].label,
                                    value: details[field].value,
                                    displayValue: details[field].displayValue,
                                    type: fields[field].type,
                                    ...(fields[field].type === 'currency' && {currency: fields[field].currency_symbol})
                                });
                            }
                        }
                        this.items = [];

                        if (details.attachments) {
                            this.descriptionAttachments = details.attachments
                        }

                        this.loaded = true;
                    }
                } catch (e) {
                    console.log(e)
                }
            },

            loadComments() {
                this.$store.dispatch('fetchList', {
                    module: 'ModComments',
                    filters: null, sort: {'orderby': 'modifiedtime', 'sortorder': 'ASC'}, parentRecord: this.record
                })
            },

            loadListAttachments(comments) {
                this.listAttachments = [...this.descriptionAttachments]

                for (let key in comments) {
                    let comment = comments[key]
                    if (comment.attachments) {
                        this.listAttachments.push(...comment.attachments)
                    }
                }
            },

            async showResolveAlert() {
                let resolveModal = this.getComponentInstance(IniModal, {
                    propsData: {
                        title: this.$t('LBL_HELPDESK_RESOLVE_ALERT_TITLE'),
                        description: this.$t('LBL_HELPDESK_RESOLVE_ALERT_DESCRIPTION'),
                        submitButtonLabel: this.$t('LBL_HELPDESK_MARK_AS_RESOLVED'),
                        closeButtonLabel: this.$t('LBL_CANCEL')
                    }
                })

                resolveModal.$mount()
                resolveModal.$on('modal-submited', () => {
                    this.updateTicketStatus('Closed')
                    resolveModal.close()
                })
                this.$refs.resolveModalContainer.appendChild(resolveModal.$el)
            },

            transformEntry(entry) {
                let handledBy = entry.customer.value ? entry.customer : entry.assigned_user_id

                if (handledBy.value === this.$store.getters.getStructure.settings.user_id) {
                    handledBy = {
                        'value': cookies.get('crmid'),
                        'displayValue': AppHelper.toUpperCaseFirstLetter(this.$t('LBL_YOU'))
                    }
                }

                let transformedEntry = {
                    body: entry.commentcontent.displayValue,
                    createdtime: this.transformDateTime(entry.createdtime),
                    handledby: handledBy,
                    isCurrentUser: entry.creator.value === this.$store.getters.getStructure.settings.user_id
                }

                if (entry.attachments) {
                    transformedEntry['attachments'] = entry.attachments
                }

                return transformedEntry;
            },
        },

        created() {
            this.loadRecordData();
            this.loadComments()
        },

        computed: {
            comments() {
                let comments = this.$store.getters.getList('ModComments')
                let transformedComments = [];

                if (comments) {
                    comments.entries.forEach((entry, index) => {
                        transformedComments.push(this.transformEntry(entry))
                    })
                }

                this.loadListAttachments(transformedComments)

                return transformedComments
            },

            isResolved() {
                if (this.ticketstatus && this.ticketstatus.value === 'Closed') {
                    return true
                }

                return false
            }
        },
    }
</script>
<style lang="scss">@import "@/assets/scss/pages/HelpDesk/_detailview.scss";</style>